import {BING_TOKEN} from '@explorer/config.js';

const BING_URL = 'https://dev.virtualearth.net/REST/v1/Locations';

export const geocode = (center, query) => {
  let url = '';
  // search by center point if there is a center point but
  //  no query string
  if (center && !query) {
    const ptStr = `${center[1]},${center[0]}`;
    url = `${BING_URL}/${ptStr}?key=${BING_TOKEN}`;
  } else {
    url = `${BING_URL}/?q=${encodeURIComponent(query)}&key=${BING_TOKEN}`;
  }
  return fetch(url)
    .then(r => r.json())
    .then(data => {
      const transformed = data.resourceSets[0]?.resources.map(r => ({
        name: r.name,
        place_name: r.name,
        bbox: [r.bbox[1], r.bbox[0], r.bbox[3], r.bbox[2]],
        properties: r, // preserve the original results
      }));

      return {
        features: transformed,
      };
    });
};
